import { PushIcon, RowIcon, PullIcon, SquatIcon } from '../Icons';
import type { Category } from '../../domain/scoring/types';
import { CATEGORY_LABELS } from '../../domain/scoring/categories';
import './CategoryCard.css';

interface CategoryCardProps {
  category: Category;
  points?: number;
  normalizedMax?: string;
  bestExerciseName?: string;
  competitionLift: string;
  onClick: () => void;
}

function truncateText(text: string, maxLength: number = 18): string {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 1).trim() + '…';
}

export function CategoryCard({
  category,
  points,
  normalizedMax,
  bestExerciseName,
  competitionLift,
  onClick,
}: CategoryCardProps) {
  const Icon = { push: PushIcon, row: RowIcon, hinge: PullIcon, squat: SquatIcon }[category];
  const label = CATEGORY_LABELS[category];
  const hasScore = points !== undefined;

  const rawName = bestExerciseName || competitionLift;
  const displayName = truncateText(rawName, 18);

  return (
    <button
      className="category-card"
      onClick={onClick}
      aria-label={`Log ${label} exercise. ${hasScore ? `Current score: ${points} points.` : 'No score yet.'}`}
    >
      <div className="category-card__icon-area">
        <Icon size={32} className="category-card__icon" />
      </div>

      <div className="category-card__info">
        <div className="category-card__name">{label}</div>
        <div className="category-card__lift" title={rawName}>
          {displayName} {normalizedMax ? `• ${normalizedMax}` : ''}
        </div>
      </div>

      <div className="category-card__score-area">
        {hasScore ? (
          <>
            <span className="category-card__points">{points}</span>
            <span className="category-card__pts-label">PTS</span>
          </>
        ) : (
          <>
            <span className="category-card__empty-dash">—</span>
            <span className="category-card__empty-label">TAP TO LOG</span>
          </>
        )}
      </div>
    </button>
  );
}
